import styled from 'styled-components';

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  height: 100%;
`;
const StyledInfoWindow = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  background-color: white;
  box-shadow: 0px 0px 4px 1px rgba(15, 23, 39, 0.1);
  padding: 1.5rem; 
  flex: 1;
  min-width: 0; 
`;

const StyledFieldNameBlock = styled.p`
  text-align: left;
  margin: 0;
  color: #052959;
  font-weight: 500;
`;

const StyledInfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: var(--color-secondary-text);
  padding: 10px 0;
  width: 100%;
  span {
    padding: 1px 6px;
    }
`;
const ScheduleHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 6rem;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
`;

const StyledSearchButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem; 
  font-weight: 700; 
  outline: none;
  height: 2.25rem;
  width: 40%; 
  background-color: #395905; 
  color: #fff;  
  cursor: pointer; 
  border: none;

  &:hover {
    background-color: #052959;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const AddContactButton = styled.button`
  padding: 0.6rem 1.2rem;
  color: #395905;
  border: none;
  font-weight: 500;
  cursor: pointer;
  font-size: 1rem;
  background-color: transparent;
  border: 1px solid #395905;

  &:hover {
    border: 1px solid #052959;
    color: #052959;
  }
  @media (max-width: 768px) {
    padding: 0.2rem 1rem;
    font-size: 0.875rem;
  }
`;

const StyledTitle = styled.h2`
  font-size: var(--font-size-s);
  font-weight: 600;
  font-family: 'Manrope', sans-serif;
  color: var(--color-primary);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  @media (max-width: 768px) {
    text-align: start;
    justify-content: flex-start;
  }
`;

const ValidationMessage = styled.div`
  color: #a6031f
  font-size: 0.875rem;
  padding: 0.75rem;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.375rem;
  margin: 1rem 0;
  text-align: center;
  font-family: 'Manrope', sans-serif;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
`;

export {
  StyledButtonWrapper,
  StyledInfoWindow,
  StyledFieldNameBlock,
  StyledInfoBlock,
  StyledSearchButton,
  AddContactButton,
  ValidationMessage,
  StyledFooter,
  StyledTitle,
  StyledHeader,
  ScheduleHeaderWrapper,
};
